import { TileBadge_badge$key } from "./__generated__/TileBadge_badge.graphql";
import { graphql } from "./taggedNode";
/**
 * Props for a Launch Tile Badge control.
 *
 * @interface TileBadgeProps
 */
export interface TileBadgeProps {
  /**
   * The underlying data for the launch tile badge.
   *
   * @type {TileBadge_badge$key}
   * @memberof TileBadgeProps
   */
  badge: TileBadge_badge$key; // Generated opaque key for the generated typing for the TileBadge_badge fragment
  /**
   * True if the badge should render with a transparent border
   */
  transparentBorder?: boolean | undefined;
  /**
   * The ID of the reader box div for screen readers to read the badge label.
   *
   * @type {string}
   */
  readerBoxId: string;
  /**
   * Current view mode of appbar
   * @type {string}
   * @memberof LaunchTileProps
   */
  viewMode: string;
  /**
   * If the Tile is currently being dragged by the user for Drag and Drop sorting
   * @type {boolean}
   * @memberof LaunchTileProps
   */
  isDragging?: boolean;
  /**
   * If the Tile should use Mercury Design styles for more spacing within bigger launch tiles
   */
  enableMercuryDesignStyles?: boolean;
}
// The GraphQL fragment representing the TileBadge
export const fragment = graphql`
  fragment TileBadge_badge on M365ApplicationBadge {
    __typename
    ... on M365ApplicationNumericBadge {
      count
      countDescription
    }
    ... on M365ApplicationDotBadge {
      description
    }
    ... on M365ApplicationStringBadge {
      text
      textDescription
    }
  }
`;
